export class SubjectModel {
    public SubjectID:number; 
    public SubjectName:number; 
    

    public SubjectAutoComplete:any;
    public Subjectlist:SubjectModel[];
}
